import styled from 'styled-components';
export var StyledPropertyCardPhotoFallback = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledPropertyCardPhotoFallback",
  componentId: "c11n-8-111-1__sc-1rkunlu-0"
})([""]);